import React, { useEffect, useState } from 'react'
import HOC from '../../components/HOC/HOC'
import addjob from '../../css/style.module.css'
import { Link, useNavigate } from 'react-router-dom'
import { FaPlus } from "react-icons/fa6";

import { RiDeleteBin6Line } from "react-icons/ri";
import { FaRegEdit } from "react-icons/fa";
import { DeleteSuccessfullyModal, SuccessfullyModal } from '../../components/Modals/Modals';
import { deleteApi, getApi } from '../../Repository/Api';
import endPoints from '../../Repository/apiConfig';

import img2 from '../../assest/loading1.gif'


const TermsConditions = () => {
    const navigate = useNavigate()
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [data, setData] = useState({})
    const [loading, setLoading] = useState(false);
    const [selecteddata, setSelectedData] = useState(null);

    const fetchData = async () => {
        await getApi(endPoints.gettermsCondition, {
            setResponse: setData,
            setLoading,
            errorMsg: 'Failed to fetch data!'
        });
    };

    useEffect(() => {
        fetchData();
    }, []);



    const handleDelete = async () => {
        if (!selecteddata) return;

        await deleteApi(endPoints.deleteprivacypolicy(selecteddata), {
            setLoading,
            // successMsg: 'Category deleted successfully!',
            errorMsg: 'Failed to delete Privacy Policy!'
        });
        setShowDeleteModal(false);
        setShowSuccessModal(true);
        await fetchData();
        setData(null)
        setTimeout(() => setShowSuccessModal(false), 2000);
        fetchData();
    };


    const openDeleteModal = (categoryId) => {
        setSelectedData(categoryId);
        setShowDeleteModal(true);
    };

    return (
        <>
            <DeleteSuccessfullyModal
                show={showDeleteModal}
                handleClose={() => setShowDeleteModal(false)}
                handleConfirm={handleDelete}
                text="delete Terms & Conditions"
            />
            <SuccessfullyModal
                show={showSuccessModal}
                handleClose={() => setShowSuccessModal(false)}
                text="Successfully Deleted"
            />
            <div className={addjob.jobmanagementCotainer}>
                <div className={addjob.jobtoppart}>
                    <div className={addjob.pagetitle}>
                        <h6>Terms & Conditions</h6>
                    </div>
                    {data?.data ?
                        <Link to={`/termsconditions/edit/${data?.data?._id}`} className={addjob.link}>
                            <div className={addjob.rightbuttons2} onClick={() => navigate('/termsconditions/add')}>
                                <FaRegEdit color='#FFFFFF' />
                                <p>Edit Terms & Conditions</p>
                            </div>
                        </Link>
                        :
                        <div className={addjob.rightbuttons2} onClick={() => navigate('/termsconditions/add')}>
                            <FaPlus color='#FFFFFF' />
                            <p>Add New Terms & Conditions</p>
                        </div>
                    }
                </div>

                <div className={addjob.addjobcontainer}>
                    <div className={addjob.addjobsubcontainer}>
                        <div className={addjob.addjobtopic}>
                            <h6>Terms & Conditions</h6>
                            <div className={addjob.tableaction}>
                                {/* <Link to={`/termsconditions/edit/${data?.data?._id}`}>
                                    <FaRegEdit size={20} style={{ cursor: "pointer", color: "#FFA800" }} />
                                </Link> */}
                                <RiDeleteBin6Line size={20} style={{ cursor: "pointer", color: "#d9534f" }} onClick={() => openDeleteModal(data?.data?._id)} />
                            </div>
                        </div>
                        {loading ? (
                            <div className={addjob.loadingnormal}>
                                <img src={img2} alt="Loading" width={100} height={100} />
                            </div>
                        ) : (
                            data?.data ? (
                                <div className={addjob.privacypolicy}>
                                    <p>{data?.data?.description}</p>
                                </div>
                            ) : (
                                <div className={addjob.loadingnormal}>
                                    <p>No data available.</p>
                                </div>
                            )
                        )}
                    </div>
                </div>

            </div>
        </>
    )
}

export default HOC(TermsConditions)